module.exports = __webpack_public_path__ + "img/fivium-logo-reverse-RGB.a07c77e7.svg";